import './_Layout.scss';
import AppContent from '../Content/Content';
import AppHeader from '../Header/Header';
import { applicationState } from '@/states/applicationState';
import appModel from '@/states/appModel';
import AppSider from '../Sider/Sider';
import classnames from 'classnames';
import { connect } from 'react-redux';
import CustomMenu from '../../../components/CustomMenu/CustomMenu';
import { Layout } from '@arkas/coreui';
import LoadingOverlay from './LoadingOverlay';
import mutabakatModel from '@/states/mutabakatModel';
import React from 'react';
import { User } from 'oidc-client';
import userManager from '@/oidc/userManager';

type AppLayoutProps = {
  isSmallScreen: boolean;
  topMenu: boolean;
  darkTheme: boolean;
  user: User;
  collapseSider: boolean;
};

interface AppLayoutStates {
  permissionsAreReady: boolean;
}

/**
 * AppLayout Component
 */
class AppLayout extends React.Component<AppLayoutProps, AppLayoutStates> {
  constructor(props: AppLayoutProps) {
    super(props);
    this.state = {
      permissionsAreReady: true
    };
  }

  componentDidMount() {
    this.setBodyClassName();
    mutabakatModel.hubs.emutabakathub.connect();
  }

  componentWillUnmount() {
    mutabakatModel.hubs.emutabakathub.disconnect();
  }

  refreshTokenAndClaims = () => {
    userManager.signinSilent().then(() => {
      this.setPermissionsToReady();
    });
  };

  setPermissionsToReady = () => {
    this.setState({
      permissionsAreReady: true
    });
  };

  getSelectedSelfRank = () => {
    // Localstorage boşsa, priority'ye göre sıralanmış olan listenin ilk elemanı,
    // yani en yüksek priority'li rank alınıyor.
  };

  setBodyClassName = () => {
    const { darkTheme } = this.props;
    if (darkTheme) {
      document.body.className = 'theme-dark';
    } else {
      document.body.className = 'theme-default';
    }
  };

  toggleSider = (collapseSider: boolean) => {
    appModel.setCollapseSider(collapseSider);
  };

  overlayOnClick = () => {
    const { isSmallScreen, collapseSider } = this.props;
    if (isSmallScreen && !collapseSider) {
      this.toggleSider(true);
    }
  };

  switchMenu = (topMenu: boolean) => {
    appModel.setTopMenu(topMenu);
  };

  switchTheme = (darkTheme: boolean) => {
    appModel.setDarkTheme(darkTheme);
    if (darkTheme) {
      document.body.className = 'theme-dark';
    } else {
      document.body.className = 'theme-default';
    }
  };

  render() {
    const { isSmallScreen, children, topMenu, collapseSider } = this.props;
    const { permissionsAreReady } = this.state;
    return (
      permissionsAreReady && (
        <div className={classnames('app-main-layout', 'theme-default')}>
          <AppSider
            collapseSider={collapseSider}
            toggleSider={this.toggleSider}
          />
          <Layout
            className={classnames(
              'app-content-layout',
              !topMenu &&
                !isSmallScreen &&
                (collapseSider ? 'has-collapsed-sider' : 'has-full-sider')
            )}
          >
            <AppHeader
              toggleSider={this.toggleSider}
              collapseSider={collapseSider}
              switchMenu={this.switchMenu}
              switchTheme={this.switchTheme}
            />
            {topMenu && !isSmallScreen && <CustomMenu />}
            <AppContent>
              {children}
              <div
                className={classnames(
                  'overlay',
                  isSmallScreen && !collapseSider && 'active'
                )}
                onClick={this.overlayOnClick}
              />
              <LoadingOverlay collapseSider={collapseSider} />
            </AppContent>
          </Layout>
        </div>
      )
    );
  }
}

const mapStateToProps = (state: applicationState) => {
  return {
    isSmallScreen: state.appModel.isSmallScreen,
    topMenu: state.appModel.topMenu,
    darkTheme: state.appModel.darkTheme,
    collapseSider: state.appModel.collapseSider,
    user: state.oidc.user
  };
};

export default connect(mapStateToProps)(AppLayout);
